import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      color: theme.palette.denim[500],
      fontFamily: theme.typography.fontFamilyMedium,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 1,
      pointerEvents: 'auto',
      '&:empty': {
        margin: 0
      },
      [theme.breakpoints.up(1024)]: {
        fontSize: theme.typography.pxToRem(16)
      },
      '&$focused': {
        color: theme.palette.denim[500]
      },
      '&$error': {
        color: theme.palette.cardinal[500]
      },
      '&$disabled': {
        color: theme.palette.stainless[700]
      }
    },
    formControl: {
      marginBottom: theme.spacing(1),
      position: 'relative',
      transform: 'none'
    },
    disabled: {},
    focused: {},
    error: {},
    outlined: {},
    required: {}
  };
}, {
  name: 'PdsInputLabel'
});